import {HttpClient} from "@angular/common/http";
import {SharedService} from "./shared.service";
import {Injectable} from "@angular/core";
import {OrdersChartRequest} from "../_models/OrdersChartRequest";
import {Observable} from "rxjs";
import {OrdersChartResponse} from "../_models/OrdersChartResponse";
import {RemedialsChartRequest} from "../_models/RemedialsChartRequest";
import {RemedialsChartResponse} from "../_models/RemedialsChartResponse";

@Injectable({providedIn: 'root'})
export class DashboardService extends SharedService {

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  getTeamOrdersChartData(request: OrdersChartRequest): Observable<OrdersChartResponse> {
    return this.httpClient.post<OrdersChartResponse>('/api/dashboard/teamorderschart', request);
  }

  getRemedialChartData(request: RemedialsChartRequest): Observable<RemedialsChartResponse> {
    return this.httpClient.post<RemedialsChartResponse>('/api/dashboard/remedialschart', request);
  }

}
